import { render } from "./single-data.vue?vue&type=template&id=7e651dbe&scoped=true"
import script from "./single-data.vue?vue&type=script&lang=js"
export * from "./single-data.vue?vue&type=script&lang=js"

import "./single-data.vue?vue&type=style&index=0&id=7e651dbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e651dbe"]])

export default __exports__